import React from 'react';
import './CrewDisplay.scss';
import { Alert } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { MomentDateFormat } from '../MomentDateFormat';
import WeeklyJobResourceList from './WeeklyJobResourceList';

export default class LongTermScheduleResourceTable extends React.Component {
    getFilteredResources = (jobResources, isPlanningOnly) =>
        jobResources.filter(
            (r) =>
                r.isPlanningOnly == Boolean(isPlanningOnly) &&
                (r.setupChargeTypeId == null ||
                    (r.setupChargeTypeId > 0 &&
                        (r.monday > 0 ||
                            r.tuesday > 0 ||
                            r.wednesday > 0 ||
                            r.thursday > 0 ||
                            r.friday > 0 ||
                            r.saturday > 0 ||
                            r.sunday > 0)) ||
                    (r.setupChargeTypeId > 0 && r.isNew == true))
        );

    getFilteredJobResources = (isPlanningOnly) => {
        const { job } = this.props;

        return this.getFilteredResources(job.resources, isPlanningOnly);
    };

    getFlaggerGroup = () => {
        const { applicationGroups } = this.props;

        return applicationGroups.find((ag) =>
            ag.groupName.startsWith('Flagger')
        );
    };

    areAnyLocationsDefined = () => {
        const { arcGisLocations } = this.props;

        return Boolean(arcGisLocations && arcGisLocations.length > 0);
    };

    render() {
        const {
            job,
            noTopBorder,
            isForLongTermSchedule,
            longTermSchedule,
            arcGisLocations,
        } = this.props;

        if (!isForLongTermSchedule) {
            return null;
        }

        const anyResources = Boolean((job.resources ?? []).length);

        if (!anyResources) {
            return (
                <Alert color="danger" fade={false}>
                    <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        className="mr-2"
                    />
                    No resources found for this order.
                </Alert>
            );
        }

        const flaggerGroup = this.getFlaggerGroup();

        const anyLocationsDefined = this.areAnyLocationsDefined();

        const weeklyJobResources = job.weekJobResources.map((wjr) => {
            return {
                key: `tr-${moment(wjr.weekOfDate).format(
                    MomentDateFormat.ApiUrlRequest
                )}`,
                weekOfDate: wjr.weekOfDate,
                jobResources: this.getFilteredResources(
                    wjr.jobResources,
                    false
                ),
                jobOverrides: wjr.jobOverrides || [],
                jobContractPhases: wjr.jobContractPhases || [],
            };
        });

        const selectedArcGisLocation =
            (arcGisLocations || []).find(
                (agl) => agl.id == longTermSchedule.arcGisLocationId
            ) || {};

        const locationPlaceholder = selectedArcGisLocation.addrLoc;

        return (
            <div className={noTopBorder ? 'border-top-0' : undefined}>
                <WeeklyJobResourceList
                    weeklyJobResources={weeklyJobResources}
                    flaggerGroup={flaggerGroup}
                    anyLocationsDefined={anyLocationsDefined}
                    locationPlaceholder={locationPlaceholder}
                    {...this.props}
                />
            </div>
        );
    }
}
